function InitSelects(){
    if ($.fn.selectEdit) {
        $('select').selectEdit()
    }
}

export {
    InitSelects,
}
